import useAttribute from "@hooks/useAttribute"

export default function useChecks(salon: Model.Response<Admin.Resources.Salon>) {
    const finished = getFinishedAttribute(salon)

    return {
        finished
    }
}

function getFinishedAttribute(salon: Model.Response<Admin.Resources.Salon>) {
    return useAttribute(salon.data, salon => salon.type === "finished", false)
}